/*******************************************************************************
//
//
//
//  #FULL PAGE
//
//
//
*******************************************************************************/

var FullPage = (function () {
    var FullPage = function (element) {
        this.section = element;
        this.backgroundImage = this.section.querySelector(
            '.c-full-page__background-image-desktop'
        );
        this.backgroundVideo = this.section.querySelector(
            '.c-full-page__background-video'
        );

        this._setup();
    };

    FullPage.prototype = {
        _setup: function () {
            var _self = this;

            if (_self.backgroundImage) {
                _self._loadBackgroundImage();
            }

            if (_self.backgroundVideo) {
                _self._loadBackgroundVideo();
            }
        },

        _loadBackgroundImage: function () {
            var _self = this;

            if (!global.isMobile) {
                gsap.set(_self.backgroundImage, {
                    y: '-25vh',
                });

                gsap.to(_self.backgroundImage, {
                    ease: 'none',
                    y: '25vh',
                    scrollTrigger: {
                        trigger: _self.section,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: true,
                    },
                });
            }
        },

        _loadBackgroundVideo: function () {
            var _self = this;
            var video = _self.backgroundVideo.getElementsByTagName('video');

            if (!global.isMobile) {
                var sources = video[0].getElementsByTagName('source');

                for (var i = 0; i < sources.length; i++) {
                    var source = sources[i];

                    if (source.dataset.src != undefined) {
                        source.setAttribute('src', source.dataset.src);

                        video[0].load();

                        video[0].addEventListener(
                            'canplaythrough',
                            function () {
                                ScrollTrigger.create({
                                    trigger: _self.section,
                                    onEnter: function () {
                                        video[0].play();
                                    },
                                    onLeave: function () {
                                        video[0].pause();
                                    },
                                    onEnterBack: function () {
                                        video[0].play();
                                    },
                                    onLeaveBack: function () {
                                        video[0].pause();
                                    },
                                });
                            }
                        );

                        gsap.to(video, {
                            ease: 'none',
                            y: '25vh',
                            scrollTrigger: {
                                trigger: _self.section,
                                start: 'top top',
                                end: 'bottom top',
                                scrub: true,
                            },
                        });
                    }
                }
            }
        },
    };

    var init = function () {
        console.log('FullPage Init');

        var componentElements = document.querySelectorAll('.c-full-page');

        Array.prototype.forEach.call(
            componentElements,
            function (componentElement) {
                var instance = componentElement.getAttribute('data-full-page');

                if (!instance) {
                    componentElement.setAttribute(
                        'data-full-page',
                        new FullPage(componentElement)
                    );
                }
            }
        );
    };

    return {
        init: init,
    };
})();
